import { useCallback, useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { CampaignTypes } from 'features/Codes'
import HelpTooltip from 'components/tooltip/HelpTooltip'
import RadioButton from 'components/form/RadioButton'
import { useDispatch, useSelector } from 'react-redux'
import { filterEmptyChildNodes, getClipboardData, pasteAsText } from 'utils'
import { setExceptionKeywords, setKeywordExtensionYn } from '../adGroupSlice'
import ErrorText from '../../../../components/form/ErrorText'

export const convertDangerouslyHTML = textContents =>
  textContents.map(item => `<div>${item}</div>`).join('')
const ExceptionKeywords = ({ error }) => {
  const dispatch = useDispatch()
  const {
    campaign: {
      form: { campaignType },
    },
    adGroup: {
      form: { keywordExtensionYn, exceptionKeywords },
    },
  } = useSelector(state => state.ad)
  const [exceptionKeywordCount, setExceptionKeywordCount] = useState(
    exceptionKeywords.length
  )
  const [focused, setFocused] = useState(false)
  const inputRef = useRef()

  useEffect(() => {
    setExceptionKeywordCount(exceptionKeywords.length)
  }, [exceptionKeywords])

  const handleExceptionKeywordsPaste = event => {
    event.preventDefault()
    const text = getClipboardData(event)
    pasteAsText(text)
  }
  const handleExceptionKeywordsInput = event => {
    const { childNodes } = event.target
    setExceptionKeywordCount(filterEmptyChildNodes(childNodes).length)
  }
  const handleExceptionKeywordsKeyDown = event => {
    const { childNodes } = event.target
    const count = filterEmptyChildNodes(childNodes).length
    setExceptionKeywordCount(count)
    if (count >= 100 && event.key === 'Enter') {
      event.preventDefault()
    }
  }
  const handleExceptionKeywordsFocus = () => {
    setFocused(true)
  }
  const handleKeywordExtensionYnChange = useCallback(
    value => {
      dispatch(setKeywordExtensionYn(value))
    },
    [dispatch]
  )
  const handleExceptionKeywordsChange = useCallback(
    event => {
      setFocused(false)
      const { childNodes } = event.target
      const textContents = [
        ...new Set(
          filterEmptyChildNodes(childNodes).map(text =>
            campaignType === CampaignTypes.TALK_CHANNEL
              ? text.replace(/\s+/g, '')
              : text.toLowerCase().replace(/\s+/g, '')
          )
        ),
      ].slice(0, 100)
      dispatch(setExceptionKeywords(textContents))
      event.target.innerHTML = convertDangerouslyHTML(textContents)
    },
    [dispatch, campaignType]
  )
  const handleLabelClick = () => {
    setTimeout(() => inputRef.current?.focus(), 0)
  }
  return (
    <div
      className={classNames('area_item', {
        error,
      })}>
      <strong className="subtit_box">
        {campaignType === CampaignTypes.TALK_CHANNEL ? (
          <>
            분절 키워드
            <HelpTooltip>
              광고그룹 하위에 등록된 키워드를 2글자 이상 자모음 분절한 키워드에
              <br />
              광고를 노출시켜 유입시키는 것을 의미합니다.
            </HelpTooltip>
          </>
        ) : (
          <>
            키워드확장
            <HelpTooltip>
              광고그룹 하위에 등록된 키워드외에 연관된 키워드에
              <br />
              자동으로 광고를 노출시키는것을 의미합니다.
            </HelpTooltip>
          </>
        )}
      </strong>
      <div className="cont_card">
        <div className="item_card">
          <div className="filter_radio">
            <RadioButton
              name="keywordExtensionYn"
              value="Y"
              label="설정"
              tiaraAction="키워드확장_설정_클릭"
              checked={keywordExtensionYn === 'Y'}
              onValueChange={handleKeywordExtensionYnChange}
            />
            <RadioButton
              name="keywordExtensionYn"
              value="N"
              label="미설정"
              tiaraAction="키워드확장_미설정_클릭"
              checked={keywordExtensionYn === 'N'}
              onValueChange={handleKeywordExtensionYnChange}
            />
          </div>
          {keywordExtensionYn === 'Y' && (
            <div className="box_subcard2">
              <div className="tit_item">
                <strong className="tit_detail">
                  제외 키워드 설정
                  <HelpTooltip>
                    {campaignType === CampaignTypes.TALK_CHANNEL
                      ? '분절 키워드 노출'
                      : '키워드 확장'}
                    을 설정하신 경우, 특정 키워드에 광고가 미노출되도록 설정할
                    수 있습니다.
                  </HelpTooltip>
                </strong>
              </div>
              <p className="desc_info">
                {campaignType === CampaignTypes.TALK_CHANNEL
                  ? '입력한 키워드는 사용자가 검색시 노출되지 않습니다. 광고그룹 생성 후에도 추가 할 수 있습니다.'
                  : '키워드 확장에서 제외 할 키워드를 추가하세요. 광고그룹 생성 후에도 추가 할 수 있습니다.'}
              </p>
              <div className="keyword_inp">
                <div className="box_textarea">
                  {focused === false && exceptionKeywordCount === 0 && (
                    <label
                      htmlFor="tfArea"
                      className="lab_txt"
                      onMouseDown={handleLabelClick}>
                      한 줄에 하나씩 입력하세요.
                    </label>
                  )}
                  <div
                    id="tfArea"
                    ref={inputRef}
                    className="tf_area"
                    contentEditable
                    dangerouslySetInnerHTML={{
                      __html: convertDangerouslyHTML(exceptionKeywords),
                    }}
                    onInput={handleExceptionKeywordsInput}
                    onPaste={handleExceptionKeywordsPaste}
                    onKeyDown={handleExceptionKeywordsKeyDown}
                    onFocus={handleExceptionKeywordsFocus}
                    onBlur={handleExceptionKeywordsChange}
                  />
                  <span className="txt_count">
                    <span className="txt_num">{exceptionKeywordCount}</span>
                    /100
                  </span>
                </div>
              </div>
            </div>
          )}
          <ErrorText error={error} tag="p" />
        </div>
      </div>
    </div>
  )
}
ExceptionKeywords.propTypes = {
  error: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
}
export default ExceptionKeywords
